module.exports = __webpack_public_path__ + "img/img-a3c066.png";